import { jwtDecode } from "jwt-decode";

// Nivel del vendedor de campo: solo ve "Crear acceso" y su supervisión, así que
// /tareas (la home del resto) le es inaccesible y le dejaría en bucle de redirecciones.
export const FIELD_VENDOR_LEVEL = 4;

// Techo del rango del rol nuevo. Los tres puntos que detectaban el vendedor de
// campo con `level >= FIELD_VENDOR_LEVEL` ("mayor o igual") tratan por error
// TODO nivel alto como vendedor de campo — incluido 99, el fallback de "nivel
// no legible en el JWT" (`AccessContext`, `RequireNotFieldVendor`). Con eso, un
// usuario cuya fila de `c_usuarios` no tuviera `level` GANABA el rol nuevo (dos
// secciones que no le tocan, incluida Supervisión de pruebas), y una sesión de
// admin sin `level` quedaba ATRAPADA en la rama del rol nuevo (que se evalúa
// ANTES del atajo `isAdmin`), perdiendo el CRM entero. El rango 4-10 dista de
// sobra de 99 y deja hueco para futuros subniveles del rol sin volver a tocar
// este techo; 99 sigue siendo, a propósito, "no sé qué nivel es esto" y por
// tanto fail-closed (no debe ganar ningún rol, ni el nuevo ni ningún otro).
export const FIELD_VENDOR_LEVEL_MAX = 10;

/**
 * Único criterio para detectar el rol "vendedor de campo": rango acotado
 * [FIELD_VENDOR_LEVEL, FIELD_VENDOR_LEVEL_MAX], NUNCA "mayor o igual" a secas.
 * Se usa en los tres sitios que necesitan distinguir este rol
 * (`AccessContext.canAccess`, `homePathForLevel`, `RequireNotFieldVendor`) para
 * que el criterio no diverja entre ellos.
 */
export function isFieldVendorLevel(level) {
  if (level == null) return false;
  const lvl = Number(level);
  if (!Number.isFinite(lvl)) return false;
  return lvl >= FIELD_VENDOR_LEVEL && lvl <= FIELD_VENDOR_LEVEL_MAX;
}

// Secciones que ve el vendedor de campo (nivel >= FIELD_VENDOR_LEVEL). Es una lista
// EXPLÍCITA en código: para este rol, `AccessContext.canAccess` la usa tal cual,
// ignorando accessConfig (overrides de BD) y el `defaultLevel` de sidebarItems.jsx.
// Sin esto, un override de producción (p. ej. supervision_tablets=3) le negaría a
// este rol una sección que sí debe ver (Hallazgo B, tarea 7).
export const FIELD_VENDOR_SECTIONS = ["crear_acceso", "supervision_tablets"];

// De esas, las EXCLUSIVAS del rol: nadie con nivel < FIELD_VENDOR_LEVEL las ve,
// ni siquiera el admin. Hoy solo "crear_acceso" (defaultLevel:4 en sidebarItems.jsx
// significa "visible para TODOS" por la semántica `<=`, así que sin este bloqueo
// explícito le aparecería a Trini y a cualquier vendedor — Hallazgo A, tarea 7).
// "supervision_tablets" NO está aquí: para el resto de niveles sigue su override
// normal (3), exactamente igual que hoy.
export const FIELD_VENDOR_EXCLUSIVE_SECTIONS = ["crear_acceso"];

/** Ruta de inicio para un nivel dado. */
export function homePathForLevel(level) {
  if (level == null) return "/tareas";
  const lvl = Number(level);
  if (!Number.isFinite(lvl)) return "/tareas";
  return isFieldVendorLevel(lvl) ? "/crear-acceso" : "/tareas";
}

// NOTA (Hallazgo F, tarea 7): un JWT sin `level` legible aterriza aquí en
// `/tareas` (usuario normal), y ahora también un nivel fuera del rango del rol
// nuevo (p. ej. 99, el fallback de "nivel no legible" que usan `AccessContext`
// y `RequireNotFieldVendor`) aterriza en `/tareas` por la misma razón: 99 no es
// vendedor de campo (`isFieldVendorLevel` lo excluye a propósito, ver arriba).
// Antes de acotar el rango, `lvl >= FIELD_VENDOR_LEVEL` daba `true` para 99 y
// esta función mandaba esa sesión a `/crear-acceso`, la home de un rol que no
// le corresponde (Hallazgo 1, tarea 7).
/** Ruta de inicio del usuario de la sesión actual. */
export function currentHomePath() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return "/tareas";
    const p = jwtDecode(token);
    return homePathForLevel(p?.level ?? p?.dept_level ?? null);
  } catch {
    return "/tareas";
  }
}
